module.exports = __webpack_public_path__ + "img/apple-pay.57cc561.svg";